import { Link } from "react-router";
import { useAuth } from "../hooks/useAuth";

export default function Home() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="text-center">
      {isAuthenticated ? (
        <Link to="/notes" className="text-2xl font-bold underline">
          Go to your notes
        </Link>
      ) : (
        <h2>Please log in to access your notes.</h2>
      )}
    </div>
  );
}
